import {useSelector} from "react-redux";
import {AppRootStateType} from "../../state/store.ts";
import {useAppDispatch} from "../useAppDispatch.ts";
import {removeChannelFromBlackListTC, setChannelToBlackListTC} from "../../state/reducers/channel-reducer.ts";
import {ICampaignHistory} from "../../state/models/CampaignResponse.ts";
import {copyChannelLink, formatNumber, formatToDDMMYYYY_HHMMSS} from "../../utils/Utils.ts";
import {useTranslation} from "react-i18next";
import {formatScheduledAt} from "../../dateUtils/dateUtils.ts";

type EmojiStat = {
    emoji: string;
    type: string;
    amount: number;
};
type PlacementStatsType = {
    id: number
    title1: string
    title2: string
    desc1: string
    desc2: string
};

const useStatisticsPlacementModal = () => {
    const dispatch = useAppDispatch();

    const data = useSelector<AppRootStateType, ICampaignHistory | null>(state => state.campaigns.currentChannel);
    const isLoading = useSelector<AppRootStateType, boolean>(state => state.campaigns.isLoading);

    const blackListHandler = () => {
        if (!data?.channel.blacklisted && data) {
            dispatch(setChannelToBlackListTC({channel_id: data?.id}))
        } else if (data?.channel.blacklisted && data) {
            dispatch(removeChannelFromBlackListTC(data.id))
        }
    }
    const copyChannel = () => {
        if (data?.channel.telegram_channel_username) {
            copyChannelLink(data?.channel.telegram_channel_username)
        }
    }
    const formatEmojiStats = (emojis: EmojiStat[]): string => {
        return emojis
            .map(({emoji, amount}) => `${decodeURIComponent(JSON.parse(`"${emoji}"`))}${amount}`)
            .join(' ');
    };
    let desc1 = '-';
    if (data?.published_at) {
        desc1 = formatScheduledAt(data.published_at);
    } else if (data?.scheduled_at) {
        desc1 = formatScheduledAt(data.scheduled_at);
    }
    const {t} = useTranslation();
    const placementStats: PlacementStatsType[] = [
        {
            title1: data?.published_at ? t('modals.statsPlacement.table.publishedAt') : t('modals.statsPlacement.table.scheduledAt'),
            title2: t('modals.statsPlacement.table.deleted'),
            desc1: desc1,
            desc2: data?.deleted_at ? formatToDDMMYYYY_HHMMSS(data.deleted_at) : '-',
            id: 1
        },
        {
            title1: t('modals.statsPlacement.table.actualViews'),
            title2: t('modals.statsPlacement.table.actualLinkClicks'),
            desc1: data?.actual_views ? formatNumber(data.actual_views) : '-',
            desc2: data?.actual_link_clicks ? formatNumber(data.actual_link_clicks) : '-',
            id: 2
        },
        {
            title1: t('modals.statsPlacement.table.ctr'),
            title2: t('modals.statsPlacement.table.comments'),
            desc1: data?.actual_link_clicks ? (data.actual_views / data.actual_link_clicks).toFixed(2) + '%' : '-',
            desc2: data?.actual_comments ? formatNumber(data.actual_comments) : '-',
            id: 3
        },
        {
            title1: t('modals.statsPlacement.table.allReactions'),
            title2: t('modals.statsPlacement.table.topOf3Reactions'),
            desc1: data?.reactions ? formatNumber(data.reactions.stars) : '-',
            desc2: data?.reactions.emojis && data?.reactions.emojis.length > 0 ? formatEmojiStats(data?.reactions.emojis) : '-',
            id: 4
        },
    ];

    return {
        isLoading, data, blackListHandler, copyChannel, formatEmojiStats, placementStats
    }
}
export default useStatisticsPlacementModal;